import request from '@/utils/request';

/*案例库-列表*/
export function getCaseList(parameter) {
  return request({
    url: '/case',
    method: 'get',
    params: parameter
  })
}
/*案例库-详情*/
export function getOneCase(parameter) {
  if (parameter.id) {
    return request({
      url: '/case/' + parameter.id,
      method: 'get',
      params: parameter
    })
  } else {
    return null;
  }
}

export function hit(parameter) {
  return request({
    url: "/case/" + parameter.pkid + "/hit",
    method: 'get'
  })
}
